module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.674f50d287a8c48dc19ba404d20fe713.eot?";


//////////////////
// WEBPACK FOOTER
// ./~/font-awesome/fonts/fontawesome-webfont.eot
// module id = 1351
// module chunks = 0